import { computed } from 'vue';
import { useStore } from 'vuex';

export const useCurrentUser = () => {
  const $store = useStore();
  const currentUser = computed(() => $store.state.currentUser);

  return {
    currentUser,
    isOwner: (uid) => uid === currentUser.value.uid,
  };
};
